import React from 'react';
import { motion } from 'framer-motion';
export function Proof() {
  return <section className="py-24 px-6 bg-dark relative overflow-hidden" data-id="element-145">
      <div className="absolute inset-0 bg-radial-gold opacity-20 pointer-events-none" data-id="element-146"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="border border-gold/20 bg-darker/80 p-8 md:p-12 rounded-sm relative" data-id="element-148">
          <div className="absolute -top-6 left-8 text-6xl text-gold/30 font-serif leading-none" data-id="element-149">
            "
          </div>

          <p className="font-sans text-lg md:text-xl text-cream/90 font-light leading-relaxed italic text-center md:text-left relative z-10" data-id="element-150">
            En los primeros 7 días de aplicar el Estatus Relajado, notarás un
            cambio en el "clima" a tu alrededor. Los extraños te abrirán las
            puertas, los meseros te darán un servicio preferencial y, lo más
            importante, el tipo de hombre que antes te evitaba empezará a buscar
            excusas para iniciar una conversación contigo.
            <br data-id="element-151" />
            <br data-id="element-152" />
            <span className="text-gold font-medium" data-id="element-153">
              No es magia, es cómo funciona el sistema nervioso humano ante la
              polaridad femenina pura.
            </span>
          </p>

          <div className="absolute -bottom-10 right-8 text-6xl text-gold/30 font-serif leading-none rotate-180" data-id="element-154">
            "
          </div>
        </motion.div>
      </div>
    </section>;
}